import styled from '@emotion/styled';

export const CheckboxError = styled.div`
  height: 20px;
  color: ${({ theme }) => theme.palette.colors.error};
  font-size: ${({ theme }) => theme.fontSizes.f1};
  line-height: ${({ theme }) => theme.lineHeights.xs};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  font-family: ${({ theme }) => theme.fontFamilies.body};
`;
